import Packery from 'packery';

export default () => {
  const moreButtons = document.querySelectorAll('.c-tile__more');

  if (moreButtons.length > 0) {
    [].forEach.call(moreButtons, moreButton => {
      moreButton.addEventListener('click', event => {
        event.preventDefault();
        event.currentTarget.parentNode.classList.toggle('active');
      });
    });
  }

  const tilesContainers = document.querySelectorAll('.c-tiles__items');

  if (tilesContainers.length < 1) {
    return;
  }

  let bodyWidth = document.body.clientWidth;
  let layout = 'large';
  const tileContainersData = [];

  const detectLayout = () => {
    layout = 'large';

    if (bodyWidth < 768) {
      layout = 'small';
    } else if (bodyWidth < 1024) {
      layout = 'medium';
    }
  };

  detectLayout();

  const setupTiles = data => {
    const { container } = data;
    let tileData = null;

    if (data.positions !== null && data.positions[layout] !== undefined) {
      tileData = data.positions[layout];
      if (data.tiles.length !== tileData.positions.length) {
        tileData = null;
      }
    } else if (data.positions !== null && layout === 'large') {
      tileData = {
        height: data.positions.height,
        positions: data.positions.positions,
      };
    }

    if (tileData === null && data.packery === null) {
      [].forEach.call(data.tiles, tile => {
        // eslint-disable-next-line no-param-reassign
        tile.className = `${tile.className.replace(
          / ?c-tile--[0-9x]+/,
          '',
        )} c-tile--${tile.getAttribute('data-size')}`;
      });
      // eslint-disable-next-line no-param-reassign
      data.packery = new Packery(data.container, {
        itemSelector: '.c-tile',
        gutter: 0,
        percentPosition: true,
        transitionDuration: 0,
        columnWidth: '.c-tiles__sizer',
      });
    } else if (tileData !== null) {
      if (data.packery !== null) {
        data.packery.destroy();
        // eslint-disable-next-line no-param-reassign
        data.packery = null;
      }

      const tileSizer = data.container.querySelector('.c-tiles__sizer');

      if (tileSizer === null) {
        return;
      }

      const sizerRect = tileSizer.getBoundingClientRect();
      const tileWidth = sizerRect.width;
      const tileHeight = sizerRect.height;

      container.style.height = `${tileHeight * tileData.height}px`;

      [].forEach.call(data.tiles, (tile, tileIndex) => {
        const index = tile.hasAttribute(`data-order-${layout}`)
          ? parseInt(tile.getAttribute(`data-order-${layout}`), 10)
          : tileIndex;
        const { style } = tile;
        const positionData = tileData.positions[index];
        let size = tile.getAttribute('data-size');

        style.left = `${positionData.x * tileWidth}px`;
        style.top = `${positionData.y * tileHeight}px`;
        style.position = 'absolute';
        if (positionData.w !== undefined) {
          size = `${positionData.w}x${positionData.h}`;
        }

        // eslint-disable-next-line no-param-reassign
        tile.className = `${tile.className.replace(
          / ?c-tile--[0-9x]+/,
          '',
        )} c-tile--${size}`;
      });
    }
  };

  [].forEach.call(tilesContainers, tilesContainer => {
    const positions = tilesContainer.hasAttribute('data-positions')
      ? JSON.parse(tilesContainer.getAttribute('data-positions'))
      : null;

    const tiles = tilesContainer.querySelectorAll('.c-tile');
    const data = {
      container: tilesContainer,
      tiles,
      packery: null,
      positions,
    };

    setupTiles(data);
    tileContainersData.push(data);
  });

  let resizeTimeout = null;

  window.addEventListener('resize', () => {
    bodyWidth = document.body.clientWidth;
    detectLayout();

    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      for (let i = 0; i < tileContainersData.length; i += 1) {
        setupTiles(tileContainersData[i]);
      }
    }, 200);
  });
};



// WEBPACK FOOTER //
// ./src/scripts/modules/tiles.js